import React from "react";
import styled from "styled-components";
import { Input } from "components/generic/form/native";
import { Button } from "components/generic/kit";
import { Error } from "components/generic/form/service";
export default ({
  isToggled,
  toggleInput,
  applyPromoCode,
  code,
  coupon,
  setCode
}) => (
  <div>
    {!isToggled && (
      <Promo className="mt1 pointer" onClick={() => toggleInput(!isToggled)}>
        + Add Promo Code
      </Promo>
    )}
    {isToggled && (
      <div className="flex mt1">
        <Input
          placeholder="Enter Promo Code"
          value={code}
          onChange={e => setCode(e.target.value)}
        />
        <div className="ml2">
          <Button
            color="white"
            type="button"
            onClick={() => applyPromoCode({ promo_code: code })}
          >
            Apply
          </Button>
        </div>
      </div>
    )}
    {coupon.error && <Error>{coupon.error.message}</Error>}
  </div>
);

const Promo = styled.div`
  font-family: "CircularStd-Book";
  color: #f76367;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/PromoCode/View.js